import { useCasing } from '@/state/useCasing'

/** Interface text in the visitor's chosen case. */
export default function Cased({ children }: { children: string }) {
  return <>{useCasing()(children)}</>
}
